<section *ngIf="finished == false">
	<div class="card shadow">
		<div class="card-body position-relative">
			<div class="p-3">
				<h2 class="display-5 font-weight-bold">
					{{currentQuestion['title']}}
				</h2>
				<!-- <p *ngIf="currentQuestion['explanation']"><small>Toelichting: {{currentQuestion['explanation']}}</small></p> -->
			</div>	
			<div class="px-3 pb-3 mb-3 position-absolute" style="bottom:0;">
				<span class="btn btn-outline-success btn-lg mr-3" id="agree-button" *ngIf="showButtons" (click)="nextQuestion(currentQuestion['id'],currentQuestionGroup['questionType'],currentQuestion['answers']['agree'], $event)">Eens</span>
				<span class="btn btn-outline-danger btn-lg" id="disagree-button" *ngIf="showButtons" (click)="nextQuestion(currentQuestion['id'],currentQuestionGroup['questionType'],currentQuestion['answers']['disagree'], $event)">Oneens</span>
			</div>
		</div>
	</div>
	<div class="progress my-3">
		<div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" style="width: {{getPercentage(currentQuestionGroupIndex,currentQuestionIndex,currentQuestions.length)}};"></div>
	</div>
</section>

<section class="finished-card" *ngIf="finished == true">
	<div class="card shadow">
		<div class="card-body">
			<div class="" *ngIf="politicParty == false">
				Hier gaat iets mis. Doe de stemwijzer opnieuw.
			</div>
			<div *ngIf="politicParty != false">
				<p class="lead font-weight-bold">Jouw voorkeuren gaan uit naar... <a href="https://www.schoolwoorden.nl/begrip/{{score.getWingText()}}" target="_blank"><em>{{score.getWingText()}}</em></a>, <a href="https://www.schoolwoorden.nl/begrip/{{score.getDirectionText()}}" target="_blank"><em>{{score.getDirectionText()}}</em></a> en de partij:</p>
				<div class="bg-light p-3">
					<h1 class="font-weight-bold text-center">{{politicParty.name}}</h1>
					<p><img [src]="'./assets/partijen/'+politicParty.logo+''" class="float-left mr-2" alt="{{politicParty.name}}"> {{politicParty.description}}</p>
					<p><em><a href="{{politicParty.url}}">Lees meer over {{politicParty.name}} op Methode M.</a></em></p>
				</div>

				<h3 class="font-weight-bold mt-5">Wat denk jij bij deze uitslag?</h3>
				<div class="result-reaction">
					<div class="row">
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Boos'}" (click)="saveReaction('Boos');">
								<img [src]="'./assets/emojis/angry-face.gif'" class="mt-1" alt="Boos"/>
								<span>Boos!</span>
							</div>
						</div>
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Verbluft'}" (click)="saveReaction('Verbluft');">
								<img [src]="'./assets/emojis/astonished.gif'" class="mt-1" alt="Verbluft"/>
								<span>Verrast!</span>
							</div>
						</div>
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Geweldig'}" (click)="saveReaction('Geweldig');">
								<img [src]="'./assets/emojis/beating-heart.gif'" class="mt-1" alt="Geweldig"/>
								<span>Geweldig!</span>
							</div>
						</div>
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Huilen'}" (click)="saveReaction('Huilen');">
								<img [src]="'./assets/emojis/crying-face.gif'" class="mt-1" alt="Huilen"/>
								<span>Huilen!</span>
							</div>
						</div>
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Blij'}" (click)="saveReaction('Blij');">
								<img [src]="'./assets/emojis/beaming-face.gif'" class="mt-1" alt="Blij"/>
								<span>Blij!</span>
							</div>
						</div>
						<div class="col-4 col-md-3 col-lg-2">
							<div class="result-reaction-item" [ngClass]="{'active': reaction === 'Leuk'}" (click)="saveReaction('Leuk');">
								<img [src]="'./assets/emojis/thumbs-up-sign.gif'" class="mt-1" alt="Leuk"/>
								<span>Leuk!</span>
							</div>
						</div>
					</div>
				</div>
			</div>   

			<div class="text-center py-3">
				<button (click)="resetQuestions()" class="btn btn-success btn-sm font-weight-bold">Nog een keer!</button>
				<a *ngIf="vclientCode" href="/uitslag/{{vclientCode}}" class="btn btn-primary btn-sm font-weight-bold ml-3 text-decoration-none">Bekijk uitslagen <em>{{vclientCode}}</em></a>
			</div>

		</div>   
	</div>  				
</section>
